import React from 'react';
export function ProofBar() {
  return <div className="bg-gradient-to-br from-card-bg to-[rgba(107,0,182,0.3)] border-y border-[rgba(194,0,111,0.3)] py-3 md:py-4 px-5" data-id="element-280">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5 text-center" data-id="element-281">
        <div className="flex flex-col items-center" data-id="element-282">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-283">
            40%
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-284">
            Reducción de ansiedad Basado en protocolos de neurociencia cognitiva
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-285">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-286">
            4 Vol.
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-287">
            Colección completa — El Camino a la Recuperación
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-288">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-289">
            21 días
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-290">
            Prácticas diarias de minutos para reprogramar el ciclo
          </p>
        </div>
      </div>
    </div>;
}